import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { adminCounts, listAllCourses, type CourseRow } from '../../lib/adminApi';
import { friendlyError } from '../../lib/supabase';
import { formatPrice } from '../../lib/progress';
import { Callout, Spinner, StatTile } from '../../components/ui';
import { StatusBadge } from './AdminCourses';

export function AdminHome() {
  const [counts, setCounts] = useState<Awaited<ReturnType<typeof adminCounts>> | null>(null);
  const [courses, setCourses] = useState<CourseRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    Promise.all([adminCounts(), listAllCourses()]).then(([c, r]) => { setCounts(c); setCourses(r); }).catch((e) => setError(friendlyError(e)));
  }, []);

  if (error) return <Callout variant="error">{error}</Callout>;
  if (!counts || !courses) return <Spinner />;

  return (
    <>
      <header>
        <h1 style={{ margin: 0, fontSize: 28, lineHeight: '36px', fontWeight: 400, color: 'var(--brand)' }}>Dashboard</h1>
        <p className="small muted" style={{ margin: '4px 0 0' }}>Live figures from enrollment and progress records. Sales and revenue arrive with Stripe checkout.</p>
      </header>
      <section className="stats-grid" aria-label="Key figures">
        <StatTile label="Registered accounts" value={counts.students} />
        <StatTile label="Active enrollments" value={counts.active} />
        <StatTile label="Completed enrollments" value={counts.completed} />
        <StatTile label="Published courses" value={counts.published} />
      </section>
      <section className="stack">
        <div className="row" style={{ justifyContent: 'space-between' }}>
          <h2 style={{ margin: 0, fontSize: 20, lineHeight: '28px', fontWeight: 600, color: 'var(--brand)' }}>Courses</h2>
          <Link to="/admin/courses" style={{ fontWeight: 600, fontSize: 14 }}>Manage courses</Link>
        </div>
        <div className="table-wrap">
          <table className="table">
            <thead><tr><th>Course</th><th>Status</th><th className="num">Price</th><th className="num">Enrolled</th><th className="num">Completion</th></tr></thead>
            <tbody>
              {courses.map((c) => (
                <tr key={c.id}>
                  <td><Link to={`/admin/courses/${c.id}`} style={{ fontWeight: 600 }}>{c.title}</Link></td>
                  <td><StatusBadge status={c.status} /></td>
                  <td className="num">{c.price_cents ? formatPrice(c.price_cents, c.currency) : '—'}</td>
                  <td className="num">{c.enrolled}</td>
                  <td className="num">{c.enrolled ? `${Math.round((c.completed / c.enrolled) * 100)}%` : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
}
